import styles from "./FAQs.module.scss"

export default function FAQs({ post }) {
  return (
    <div
      className={styles.Wrapper}
      dangerouslySetInnerHTML={{ __html: post }}
    />
  )
}
